import { Box, Stack } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledFooter = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  minHeight: theme.spacing(56),
  borderTop: '1px solid',
  borderColor: theme.palette.text.fourth,
  backgroundColor: theme.palette.background.default,
  zIndex: 101,
  paddingInline: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    paddingInline: theme.spacing(4),
  },
  [theme.breakpoints.up('xl')]: {
    paddingInline: theme.spacing(20),
  },
  [theme.breakpoints.up('gs')]: {
    paddingInline: theme.spacing(20),
    width: theme.spacing(650),
    marginInline: 'auto',
    borderTop: 'none',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100vw',
      height: '1px',
      backgroundColor: theme.palette.text.fourth,
    },
  },
}));

export const StyledFooterMobileContent = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  paddingTop: theme.spacing(6),
  paddingInline: theme.spacing(5),
  [theme.breakpoints.down('md')]: {
    paddingInline: 0,
  },
}));
